module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-es-ES.77dec0cf.jpg";